import { atom } from 'recoil';

import type { DomainProperty } from '@/Swagger';

/**
 * 속성 메타데이터 타입.
 */
export type PropertyType = {
  aimsCategory: {
    raw: DomainProperty[];
    values: Record<
      string,
      {
        name: string;
        parent?: string;
        children?: string[];
      }
    >;
    ids: string[];
    groupIDs: string[];
  };
  color: {
    raw: DomainProperty[];
    values: Record<
      string,
      {
        name: string;
      }
    >;
    ids: string[];
  };
  neckShoulder: {
    raw: DomainProperty[];
    values: Record<
      string,
      {
        name: string;
      }
    >;
    ids: string[];
  };
  aimsFabric: {
    raw: DomainProperty[];
    values: Record<
      string,
      {
        name: string;
      }
    >;
    ids: string[];
  };
  aimsPattern: {
    raw: DomainProperty[];
    values: Record<
      string,
      {
        name: string;
      }
    >;
    ids: string[];
  };
};

export const propertyState = atom<PropertyType | null>({
  key: 'propertyState',
  default: null,
});
